/*
 * Copyright (c) 2017-present, flop! contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 * https://framagit.org/flopedt/flopedt
 */

import type { Plugin } from 'vue'

import { formatZonedDateTime } from '@/utils/time.ts'

export const i18nExtras: Plugin = {
  install(app) {
    app.config.globalProperties.$dx = formatZonedDateTime
  },
}

declare module 'vue' {
  interface ComponentCustomProperties {
    $dx: typeof formatZonedDateTime
  }
}
